import React, { useState } from 'react'
import Select from "react-select";
import { useDispatch } from 'react-redux';
import { agregarRelacionCentrosMedicos } from '../../../../../actions/medicos';


export const SelectCentrosMedicos = (props) => {

const { CentrosMedicosAsignados,  CentrosMedicosOptions, CentrosMedicosItems, IdEfectorRed} = props;
const [asignadosCM, setAsignadosCM] = useState(CentrosMedicosAsignados);
const dispatch = useDispatch()

const handleCheckboxChange = (selectedOptions) => {
    const asignadosE = selectedOptions.map(option => ({
      centroMedico: {
        idCentroMedico: option.value,
        descripcionCentro: option.label
      }
    }));
    setAsignadosCM(asignadosE);
    const idsCentro = asignadosE.map(({ centroMedico: { idCentroMedico } }) => idCentroMedico);
    dispatch(agregarRelacionCentrosMedicos(IdEfectorRed, idsCentro));
  };

const valor = asignadosCM?.map((x) => {
    const centro = CentrosMedicosItems.find(
        
          (e) => e.idCentroMedico === x.centroMedico.idCentroMedico
    );
    return centro
      ? {
          value: centro.idCentroMedico,
          label: centro.descripcionCentro,
        }
      : undefined;
  })


  return (
            <Select
               fullWidth
               isMulti
               onChange={handleCheckboxChange}
               value={valor}
               options={CentrosMedicosOptions}
               placeholder="Seleccione Centros Medicos..."  
               styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
               menuPosition="fixed"
            />
  )
}
